import { render } from "./CourierList.vue?vue&type=template&id=dcc74c44"
import script from "./CourierList.vue?vue&type=script&lang=js"
export * from "./CourierList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__